
import { ModuleConfig } from '@/core/module';
import { actionFlowRoutes } from './routes';
import { useConfigurationStore } from './config/stores/configurationStore';
import { useRequestStore } from './runtime/stores/requestStore';

export const ActionFlowModule: ModuleConfig = {
    name: 'action-flow',
    routes: actionFlowRoutes,
    stores: {
        configuration: useConfigurationStore,
        request: useRequestStore
    },
    initialize: () => {
        console.log('Action Flow module initialized');
    }
};
